__turbopack_context__.v({
  "saleFilterTrigger": "styles-module__Q1OvfG__saleFilterTrigger",
});
